export enum XpressClientLocationTypeEnum {
    None = 0,
    Xpress = 1,
    Boracay = 2,
	ElNido = 3,
	Dumaguete = 4
}
